<template>
  <div class="page-top-banner">
    <div class="page-top-banner-left-content">
      <slot name="left-content">
        <div class="left-content-inner">
          <div class="left-content-title">{{ title }}</div>
          <div class="left-content-desc">{{ desc }}</div>
        </div>
        <div class="left-content-decorate">
          <img src="~assets/image/page-top-banner/common-decorate-left.svg" />
        </div>
      </slot>
    </div>
    <div class="page-top-banner-right-content">
      <div class="right-content-img">
        <slot name="right-content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
// 页面顶部的banner图
export default {
  name: 'page-banner',
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
  }
};
</script>

<style lang="scss" scoped>
.page-top-banner {
  width: 100%;
  height: 96px;
  background: linear-gradient(270deg, #ecf4ff 0%, #d1e4ff 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  pointer-events: none;

  &-left-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 32px;
    position: relative;
    flex: 1;

    .left-content-inner {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 6;
    }

    .left-content-title {
      font-size: 16px;
      font-weight: bold;
      color: #333840;
      line-height: 24px;
      margin-bottom: 4px;
    }

    .left-content-desc {
      font-size: 12px;
      color: #6d7582;
      line-height: 20px;
    }

    .left-content-decorate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 90px;
      height: 56px;
      z-index: 5;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &-right-content {
    flex: 1;
    height: 100%;
    position: relative;

    .right-content-img {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 500px;
      height: 120px;
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
